module.exports = __webpack_public_path__ + "static/img/3.b12e7d0b.jpg";